import React from 'react';
import { ChevronDown, Mail, Phone, MapPin } from 'lucide-react';
import { HeroSectionProps } from '@/types';

const HeroSection: React.FC<HeroSectionProps> = ({ contactInfo, onNavigate }) => {
  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-blue-900/20 via-purple-900/20 to-gray-900"></div>
      <div className="absolute inset-0">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-blue-500/10 rounded-full blur-3xl"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-purple-500/10 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 text-center max-w-4xl mx-auto px-6">
        <h1 className="text-5xl md:text-7xl font-bold mb-6">
          <span className="bg-gradient-to-r from-blue-400 via-purple-500 to-blue-600 bg-clip-text text-transparent">
            Stephen Wolfe
          </span>
        </h1>
        <h2 className="text-2xl md:text-3xl text-gray-300 mb-8">
          Cloud Solutions Expert | DevOps Advocate | Cost Efficiency Specialist
        </h2>
        <p className="text-xl text-gray-400 mb-12 max-w-2xl mx-auto leading-relaxed">
          Adept at designing scalable, secure, and automated infrastructure with expertise in Kubernetes, AWS, and modern DevOps practices
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-16">
          <div className="flex items-center gap-2 text-gray-300">
            <MapPin className="w-5 h-5 text-blue-400" />
            {contactInfo.location}
          </div>
          <div className="flex items-center gap-2 text-gray-300">
            <Phone className="w-5 h-5 text-blue-400" />
            {contactInfo.phone}
          </div>
          <div className="flex items-center gap-2 text-gray-300">
            <Mail className="w-5 h-5 text-blue-400" />
            {contactInfo.email}
          </div>
        </div>

        <button
          onClick={() => onNavigate('about')}
          className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-500 to-purple-600 px-8 py-4 rounded-lg font-semibold hover:from-blue-600 hover:to-purple-700 transition-all duration-300 transform hover:scale-105"
        >
          Learn More
          <ChevronDown className="w-5 h-5" />
        </button>
      </div>
    </section>
  );
};

export default HeroSection;